// 移动端路由
export default [
      // ==================1、首页=====================
      {
        path: "mb_home",
        name: "mb_home",
        component: () => import('@/views/mbHome')
      },
      // =================== 2、产品中心 =================
       // 2、1产品中心-列表
      {
        path: "mbProduct",
        name: "mbProduct",
        component: () => import('@/views/mobile/product/list')
      },
       // 2.2产品中心-硬件产品
      {
        path: "mbHardware",
        name: "mbHardware",
        component: () => import('@/views/mobile/product/hardware')
      },
       // 2.3产品中心-软件产品（焊接云系统）
       {
        path: "mbCloud",
        name: "mbCloud",
        component: () => import('@/views/mobile/product/mbWeldCloud')
      },
       // 2.4 产品中心-软件产品(压力容器，钢结构，智慧焊培，焊工信息，智能焊缝，智能视讯，智能机器人，管道焊接，焊接工艺，焊材库，奥太微群控小程序，奥太资料库)
        {
        path: "mbSoftware",
        name: "mbSoftware",
        component: () => import('@/views/mobile/product/software')
      },
        // 2.5产品中心-软件产品app(掌上群控，掌上焊机，掌上运维)
      {
          path: "mbSoftwareApp",
          name: "mbSoftwareApp",
          component: () => import('@/views/mobile/product/softwareApp')
      },
      // =================== 3、解决方案 =================
      //   3.1解决方案-列表
      {
            path: "mbSolutionList",
            name: "mbSolutionList",
            component: () => import('@/views/mobile/solution/list')
      },
      //   3.2解决方案-详情
      {
            path: "mbSolutionDetail",
            name: "mbSolutionDetail",
            component: () => import('@/views/mobile/solution/detail')
      },
      // =================== 4、应用案例 =================
        {
            path: "mbCase",
            name: "mbCase",
            component: () => import('@/views/mobile/case/list')
        },
        // =================== 5、新闻资讯 =================
        // 5.1新闻资讯--列表
        {
            path: "mbNews",
            name: "mbNews",
            component: () => import('@/views/mobile/news/list')
        },
          // 5.2 新闻资讯--详情
        {
            path: "mbNewsDetail",
            name: "mbNewsDetail",
            component: () => import('@/views/mobile/news/detail')
        },
        // =================== 6、资料中心 =================
        // 6.1资料中心-资料下载
        {
            path: 'mbResourceDownload',
            name: 'mbResourceDownload',
            meta: {
              title: '资料中心-资料下载',
            },
            component: () => import('@/views/mobile/resource/resourceDownload')
        },
         // 6.2资料中心-行业标准
         {
            path: 'mbIndustry',
            name: 'mbIndustry',
            meta: {
              title: '资料中心-行业标准',
            },
            component: () => import('@/views/mobile/resource/industry')
        },
         // 6.3资料中心-焊工小知识
         {
            path: 'mbCertificate',
            name: 'mbCertificate',
            meta: {
              title: '资料中心-焊工小知识',
            },
            component: () => import('@/views/mobile/resource/certificate')
        },
        // =================== 7、视频资料 =================
          {
            path: 'mbVideo',
            name: 'mbVideo',
            meta: {
              title: '视频资料',
            },
            component: () => import('@/views/mobile/video/index')
        },
        // =================== 8、关于我们 =================
        {
            path: 'mbAbout',
            name: 'mbAbout',
            meta: {
                title: '联系我们',
            },
            component: () => import('@/views/mobile/about/index')
        },
        // =================== 9、系统配置 =================
        {
            path: 'mbSystem',
            name: 'mbSystem',
            meta: {
                title: '系统配置',
            },
            component: () => import('@/views/mobile/system')
        },
  ]

